module.exports = __webpack_public_path__ + "img/bg_slide_5.867bb4c3.jpg";